import { render, staticRenderFns } from "./EmailInfo.vue?vue&type=template&id=a4866ab4&scoped=true&"
import script from "./EmailInfo.vue?vue&type=script&lang=js&"
export * from "./EmailInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmailInfo.vue?vue&type=style&index=0&id=a4866ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4866ab4",
  null
  
)

export default component.exports